var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',_vm._g(_vm._b({staticClass:"mb-5",attrs:{"outlined":_vm.outlined,"dense":!_vm.$_isMobile,"type":_vm.type}},'v-text-field',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }